import { render, staticRenderFns } from "./modal_price.vue?vue&type=template&id=1f98a5ca&"
import script from "./modal_price.vue?vue&type=script&lang=js&"
export * from "./modal_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports